import axios from 'axios';
import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const createEvent = (values: any) => {
	return clientApi.post(`${backendUrl}/event`, values);
};

const retrieveAllEvents = (locationParams?: string | Record<string, any>) => {
	let queryString = '';
	
	if (typeof locationParams === 'string') {
		queryString = locationParams.startsWith('?') ? locationParams : `?${locationParams}`;
	} else if (locationParams && typeof locationParams === 'object') {
		const params = new URLSearchParams();
		Object.keys(locationParams).forEach(key => {
			if (locationParams[key] !== undefined && locationParams[key] !== null) {
				params.append(key, String(locationParams[key]));
			}
		});
		queryString = params.toString() ? `?${params.toString()}` : '';
	}
	
	return clientApi.get(`${backendUrl}/event${queryString}`);
};

const retrieveAllEventsForAdmin = (params?: Record<string, any>) => {
	let queryString = '';
	
	if (params && typeof params === 'object') {
		const searchParams = new URLSearchParams();
		Object.keys(params).forEach(key => {
			if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
				searchParams.append(key, String(params[key]));
			}
		});
		queryString = searchParams.toString() ? `?${searchParams.toString()}` : '';
	}
	
	return clientApi.get(`${backendUrl}/admin/events/all${queryString}`);
};

const retrieveEvent = (id: string) => {
	return clientApi.get(`${backendUrl}/event/${id}`);
};

//@ts-ignore
const updateEvent = (id, event) => {
	return clientApi.put(`${backendUrl}/event/${id}`, event);
};

const deleteEvent = (id: string) => {
	return clientApi.delete(`${backendUrl}/event/${id}`);
};

export const approveEvent = (
	eventId: string,
	payload: { serviceFee: number; serviceFeeType: 'percentage' | 'flat' },
) => {
	return clientApi.put(`${backendUrl}/admin/events/approve/${eventId}`, payload);
};

export const rejectEvent = (eventId: string) => {
	return clientApi.put(`${backendUrl}/admin/events/reject/${eventId}`);
};

const eventService = {
	createEvent,
	retrieveAllEvents,
	retrieveAllEventsForAdmin,
	retrieveEvent,
	updateEvent,
	deleteEvent,
	approveEvent,
	rejectEvent,
};

export default eventService;
